import { loginFormData } from '@reducers/login';
import intro from '@reducers/app/intro';
import upgrade from '@reducers/upgrade';
import router from '@reducers/app/router';
import epassport from '@reducers/epassport';

export default {
  loginFormData,
  intro,
  upgrade,
  router,
  epassport,
};



// WEBPACK FOOTER //
// ./reducers/pages/login.js